import Model, { attr } from '@warp-drive/legacy/model';

import {
  buildValidations,
  validator,
} from 'umg-ember-backend/utils/validations';

const Validations = buildValidations({
  name: [
    validator('presence', true),
    validator('format', {
      regex: /^[a-z0-9-.]+\.[a-z0-9-.]+$/,
    }),
  ],
});

export default class DomainModel extends Model.extend(Validations) {
  @attr('string') name;

  // Getter and setter
  get displayHeadline() {
    return this.name;
  }

  get displayLabel() {
    return `${this.name} (${this.id})`;
  }
}
